"use strict";
"use client";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _ButtonPrimitive = _interopRequireDefault(require("../primitives/ButtonPrimitive"));
var _getIconContainer = _interopRequireDefault(require("../primitives/ButtonPrimitive/common/getIconContainer"));
var _getCommonProps = _interopRequireDefault(require("../primitives/ButtonPrimitive/common/getCommonProps"));
var _ChevronForward = _interopRequireDefault(require("../icons/ChevronForward"));
var _useTheme = _interopRequireDefault(require("../hooks/useTheme"));
var _getSocialButtonStyles = _interopRequireDefault(require("./helpers/getSocialButtonStyles"));
var _getSocialButtonIconForeground = _interopRequireDefault(require("./helpers/getSocialButtonIconForeground"));
var _getSocialButtonIcon = _interopRequireDefault(require("./helpers/getSocialButtonIcon"));
var _consts = require("./consts");
const SocialButton = /*#__PURE__*/React.forwardRef(({
  type = _consts.TYPE_OPTIONS.APPLE,
  disabled = false,
  size,
  ...props
}, ref) => {
  const theme = (0, _useTheme.default)();
  const propsWithTheme = {
    theme,
    size,
    ...props
  };
  const commonProps = (0, _getCommonProps.default)(propsWithTheme);
  const buttonStyles = (0, _getSocialButtonStyles.default)({
    type,
    disabled,
    theme
  });
  const icons = (0, _getIconContainer.default)({
    ...propsWithTheme,
    iconForeground: (0, _getSocialButtonIconForeground.default)({
      type,
      theme
    })
  });
  const iconLeft = (0, _getSocialButtonIcon.default)(type);
  return /*#__PURE__*/React.createElement(_ButtonPrimitive.default, (0, _extends2.default)({
    ref: ref
  }, props, commonProps, buttonStyles, icons, {
    disabled: disabled,
    iconLeft: iconLeft,
    iconRight: /*#__PURE__*/React.createElement(_ChevronForward.default, {
      customColor: type === _consts.TYPE_OPTIONS.APPLE ? "#FFF" : "",
      color: "primary"
    }),
    circled: false
  }));
});
SocialButton.displayName = "SocialButton";
var _default = SocialButton;
exports.default = _default;